import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import toast from "react-hot-toast";
import { UserData } from "../context/userContext";
import { LoaderData } from "../context/loaderContext";
import Loader from "../components/Loader/Loader";
import { USER_REGISTRATION_CLOSED } from "../constants/events";
import "../styles/RegisterDetails.css";
/* Need to ensure that this page has been deployed and changed correctly */
function RegisterDetails() {
  const { email, token } = useParams();
  const navigate = useNavigate();
  const { register } = UserData();
  const [btnLoading, setBtnLoading] = useState(false);
  const [isPassword, setIsPassword] = useState("password");
  const [isConfirmPassword, setIsConfirmPassword] = useState("password");
  const [formData, setFormData] = useState({
    name: "",
    college: "",
    dept: "",
    year: "",
    mobile: "",
    referralCode: "",
    password: "",
    confirmPassword: "",
  });

  const optionsYear = [
    { label: "First year", value: "1" },
    { label: "Second year", value: "2" },
    { label: "Third year", value: "3" },
    { label: "Fourth year", value: "4" },
    { label: "Fifth year", value: "5" },
  ];

  const handleMobileChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      if (e.target.value.length <= 10) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          mobile: e.target.value,
        }));
      }
    }
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (USER_REGISTRATION_CLOSED) {
      toast.error("User registration is now closed!");
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate password match
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    // Validate mobile number length
    if (formData.mobile.length !== 10) {
      toast.error("Mobile number must be exactly 10 digits!");
      return;
    }

    // Validate password strength
    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long!");
      return;
    }

    setBtnLoading(true);

    try {
      const response = await register(
        {
          name: formData.name,
          email,
          token,
          college: formData.college,
          dept: formData.dept,
          year: parseInt(formData.year),
          mobile: formData.mobile,
          referralCode: formData.referralCode,
          password: formData.password,
        },
        navigate,
      );

      if (!response) {
        return;
      }

      // Show success message and redirect to login
      toast.success("Registration successful! Redirecting to login...");

      // Reset form
      setFormData({
        name: "",
        college: "",
        dept: "",
        year: "",
        mobile: "",
        referralCode: "",
        password: "",
        confirmPassword: "",
      });

      // Redirect to login page immediately
      navigate("/auth", { state: { showLogin: true } });
    } catch (err) {
      // Error toast already handled in context
    } finally {
      setBtnLoading(false);
    }
  };
  const { isLoading } = LoaderData();

  if (isLoading || USER_REGISTRATION_CLOSED) {
    return <Loader />;
  }
  return (
    <div
      className="register-details-container"
      style={{
        minHeight: "calc(100vh - 80px)",
        paddingTop: "80px",
        paddingBottom: "40px",
      }}
    >
      <div className="register-details-card">
        <div className="register-details-title">
          <span>&#60;</span> Sign up <span>&#62;</span>
        </div>
        <form className="register-details-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            className="register-details-input"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="college"
            placeholder="College"
            className="register-details-input"
            value={formData.college}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="dept"
            placeholder="Department"
            className="register-details-input"
            value={formData.dept}
            onChange={handleChange}
            required
          />
          <select
            className="register-details-select"
            value={formData.year}
            onChange={(e) => handleSelectChange("year", e.target.value)}
            required
          >
            <option value="" disabled>
              Select Year of Study
            </option>
            {optionsYear.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <input
            type="text"
            name="mobile"
            placeholder="Mobile (10 digits)"
            className="register-details-input"
            value={formData.mobile}
            onChange={handleMobileChange}
            maxLength="10"
            minLength="10"
            required
          />
          <input
            type="text"
            name="referralCode"
            placeholder="Referral Code (optional)"
            className="register-details-input"
            value={formData.referralCode}
            onChange={handleChange}
          />
          <div className="register-details-password-wrap">
            <input
              type={isPassword}
              name="password"
              placeholder="Password (min 6 characters)"
              onChange={handleChange}
              value={formData.password}
              minLength="6"
              required
            />
            <span
              className="register-details-password-icon"
              onClick={() =>
                setIsPassword((prev) =>
                  prev === "password" ? "text" : "password",
                )
              }
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === "Enter" &&
                setIsPassword((prev) =>
                  prev === "password" ? "text" : "password",
                )
              }
            >
              {isPassword === "password" ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          <div className="register-details-password-wrap">
            <input
              type={isConfirmPassword}
              name="confirmPassword"
              placeholder="Confirm Password"
              onChange={handleChange}
              value={formData.confirmPassword}
              required
            />
            <span
              className="register-details-password-icon"
              onClick={() =>
                setIsConfirmPassword((prev) =>
                  prev === "password" ? "text" : "password",
                )
              }
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === "Enter" &&
                setIsConfirmPassword((prev) =>
                  prev === "password" ? "text" : "password",
                )
              }
            >
              {isConfirmPassword === "password" ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          <button
            type="submit"
            className="register-details-submit"
            disabled={btnLoading}
          >
            {btnLoading ? "Registering..." : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RegisterDetails;
